<template>
  <div class="footer">
    <div class="footer-content">
      <div class="footer-top">
        <div class="logo">
          <img src="@/assets/logo1.png" alt="泽润软件" />
        </div>
        <div class="nav-links">
          <div class="link-group">
            <h3>进一步了解</h3>
            <ul>
              <li @click="getPoint('products4')">服务与保障</li>
              <li @click="getPoint('user1')">关于泽润</li>
              <li @click="getPoint('user2')">企业文化</li>
              <li @click="getPoint('user3')">合作伙伴</li>
            </ul>
          </div>
          <div class="link-group">
            <h3>解决方案</h3>
            <ul>
              <li @click="getPoint('case1')">全渠道数字化信息平台</li>
              <li @click="getPoint('case2')">AISM智能供应协同管理方案</li>
              <li @click="getPoint('case3')">AICM数字化智能会员营销方案</li>
              <li @click="getPoint('case4')">AIAM人脸识别终端考勤解决方案</li>
            </ul>
          </div>
          <div class="link-group">
            <h3>泽润产品</h3>
            <ul>
              <li @click="getPoint('products1')">样衣库存管理</li>
              <li @click="getPoint('products2')">培训考试管理</li>
              <li @click="getPoint('products3')">企业快递助手</li>

            </ul>
          </div>
          <!-- <div class="link-group">
            <div class="hotline">
                📞
              <span class="icon">咨询热线</span>
              <span class="phone">18033068477</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="footer-divider"></div>
      <div class="footer-bottom">
        <div class="contact-details">
            <!-- 邮箱: zerunsoft@yingerfashion.com -->
          <p>咨询热线: 18033068477 </p>
        </div>
        <div class="copyright">
          <p>Copyright © 2025-2026 www.zerunsys.com All Rights reserved 深圳泽润数字软件科技有限公司版权所有 粤ICP备2025470351号</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomFooter",
  components: {},
  props: {},
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    // getPoint(id) {
      
    // },
  getPoint(id) {
    // 根据id判断需要跳转到哪个页面
    let activeName;
    if (id.includes('case')) {
      activeName = '2'; // 解决方案页面
    } else if (id.includes('products')) {
      activeName = '1'; // 产品方案页面
    } else if (id.includes('user')) {
      activeName = '4'; // 关于我们页面
    }
    console.log(id, activeName);

    
    // 调用父组件的goServe方法，切换页面并设置point
    this.$parent.$parent.goServe({ point: id, activeName: activeName });
    
    // // 等待页面切换完成后滚动到对应元素
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     const element = document.getElementById(id);
    //     if (element) {
    //       // 计算滚动位置，考虑导航栏高度
    //       const navHeight = 70; // 导航栏高度
    //       const elementTop = element.offsetTop - navHeight;
          
    //       // 平滑滚动到目标元素
    //       window.scrollTo({
    //         top: elementTop,
    //         behavior: 'smooth'
    //       });
    //     }
    //   }, 100); // 给页面切换一些时间
    // });
  }
}

};
</script>
<style lang="less" scoped>
.footer {
  background-color: #000;
  color: #fff;
  padding: 40px 0;
  font-size: 14px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
}

.logo img {
  width: 120px;
  height: auto;
}

.nav-links {
  display: flex;
  justify-content: space-between;
  width: 65%;
}

.link-group {
  margin-right: 60px;
}

.link-group h3 {
  text-align: left;
  font-size: 16px;
  margin-bottom: 15px;
  font-weight: bold;
}

.link-group ul {
    text-align: left;
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-group ul li {
  margin-bottom: 8px;
  cursor: pointer;
//   opacity: 0.8;
//   transition: opacity 0.1s;
}

.link-group ul li:hover {
  color: #3b5fe3;
//   opacity: 1;
}
.hotline {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 10px;

}

.hotline .icon {
  margin-bottom: 15px;
  font-size: 18px;
  display: flex;
  align-items: center;
}
.hotline .icon::before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  background: url("../assets/icons/电话.png") center/contain no-repeat;
}

.hotline .phone {
  font-size: 16px;
  font-weight: bold;
}

.footer-divider {
  border-top: 1px solid #333;
  margin-bottom: 20px;
}

.footer-bottom {
  text-align: center;
  line-height: 1.6;
  opacity: 0.8;
}

.contact-details p {
    font-size: 16px;
  margin-bottom: 10px;
}
.copyright{
    color: #666;
}
</style>